__turbopack_context__.v({
  "below": "LCatalogThreeCols-module__oDtZ1G__below",
  "content": "LCatalogThreeCols-module__oDtZ1G__content",
  "leftSidebar": "LCatalogThreeCols-module__oDtZ1G__leftSidebar",
  "mainColumn": "LCatalogThreeCols-module__oDtZ1G__mainColumn",
  "rightSidebar": "LCatalogThreeCols-module__oDtZ1G__rightSidebar",
  "root": "LCatalogThreeCols-module__oDtZ1G__root",
});
